class CopyClipBoard {

    checkPermission() {
        return new Promise((resolve, reject) => {
            navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
                if (result.state === "granted" || result.state === "prompt") {
                    /* write to the clipboard now */
                    resolve();
                } else {
                    reject();
                }
            });
        })

    }

    async copy(newClip) {
        await this.checkPermission();
        navigator.clipboard.writeText(newClip).then(() => {
            /* clipboard successfully set */
            $.notify({
                title: 'Notification',
                message: 'Content Copied'
            }, {
                placement: {
                    from: "bottom",
                    align: "right"
                },
                allow_dismiss: false,
                type: 'minimalist',
                delay: 4000,
                icon_type: 'image',
                template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                    '<img data-notify="icon" class="img-circle pull-left">' +
                    '<span data-notify="title">{1}</span>' +
                    '<span data-notify="message">{2}</span>' +
                    '</div>'
            });
        }, () => {
            /* clipboard write failed */
        });
    }
}

export default CopyClipBoard;